import { useRef } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { message } from "antd";

export const useOrderPdfDownload = () => {
  const printRef = useRef(null);

  const downloadPdf = async (filename) => {
    const element = printRef.current;
    if (!element) {
      message.error("Nothing to export");
      return;
    }

    try {
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        useCORS: true,
        width: element.scrollWidth,
        height: element.scrollHeight,

      });

      const imgData = canvas.toDataURL("image/jpeg", 0.98);

      const pdf = new jsPDF({
        unit: "pt",
        format: "a4",
        orientation: "portrait",
      });

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      // First page
      pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      // Additional pages if content is longer than one page
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save(filename);
    } catch (err) {
      console.error("PDF generation failed:", err);
      message.error("Failed to generate PDF");
    }
  };

  return { printRef, downloadPdf };
};

